<template>
  <div class="money" :style="{ lineHeight: props.size + 'px' }">
    <text :style="{ fontSize: props.size - 4 + 'px' }">￥</text>
    <text :style="{ fontSize: props.size + 'px' }">
      {{ $priceFormat(props.value) }}
    </text>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Number,
      default: 0,
    },
    size: {
      type: Number,
      default: 14,
    },
  },
  setup(props) {
    return { props };
  },
};
</script>
<style lang="less" scoped>
.money {
  display: flex;
  width: fit-content;
  align-items: baseline;
  color: #f00;
}
</style>
